import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './WrapperTemplate.scss';

export const WrapperTemplate = ({ wrapTitle, children, wrapClassName }) => {
    const { t } = useTranslation();
    return (
        <>
            <h4 className={`wrap-title ${wrapClassName}`}>{t(wrapTitle)}</h4>
            {children}
        </>
    );
};

WrapperTemplate.prototype = {
    wrapTitle: PropTypes.string,
    children: PropTypes.node,
};